export default "__VITE_ASSET__CRoWvdq6__"